import React from "react";
import { Icon, ColorProps, SpaceProps, LayoutProps, BackgroundProps, BorderProps, IconProps } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { IconVariant } from "@/utils/fontAwesomeUtils";

interface Props extends SpaceProps, ColorProps, LayoutProps, BackgroundProps, BorderProps, IconProps {
	variant?: IconVariant;
	/**
	 * Example: "fa-arrows-to-eye"
	 */
	icon: string;
	boxSize?: string | number;
}

/**
 * A Chakra wrapper for the FontAwesomeIcon component, following best practices according to Chakra and FontAwesome.
 *
 * See: https://docs.fontawesome.com/web/use-with/react/add-icons and https://v2.chakra-ui.com/docs/components/icon/usage#using-a-third-party-icon-library
 */
export const ChakraFAIcon = ({ variant = "regular", icon, ...props }: Props): JSX.Element => {
	return <Icon as={FontAwesomeIcon} icon={`fa-${variant} ${icon}` as IconProp} {...props} />;
};
